const getCustomerBundles = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}Promotiongroup/customerbundles`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}


const getSupplierBundles = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}Promotiongroup/supplierbundles`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}

const getCompany = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}company/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}


const SKU = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };

    await fetch(`${ApiURL}Promotion/PromotionskuSelect`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}


const SKUBundle = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };

    await fetch(`${ApiURL}Promotion/PromotionskubundleSelect`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}


const getTickets = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };

    await fetch(`${ApiURL}Ticket/Select`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}


const savePromotion = async (promotionOBJ) => {
    const authToken = localStorage.getItem("authToken");
    const ApiURL = window.Links.ApiURL;

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(promotionOBJ)
    };

    try {

        const response = await fetch(`${ApiURL}Promotion`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, message: result.data };
        }
        return { success: false, message: result.data };

    } catch (error) {
        console.error('Error:', error);
        // Return an empty array or handle the error as needed.
        return { success: false, message: error };
    }
}


const getPaymentModes = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = [];
    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}Paymode/paymodedetailshead`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        })
        .catch(error => console.log('error', error));
    return data;
}

const getPromotionLocations = async (logUser) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");
        
        const requestOptions = {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: "follow",
        };

        const response = await fetch(`${ApiURL}Locations/promotion/${logUser}`, requestOptions);
        const result = await response.json();
        
        const data = result.data.map((dr, index) => ({
            id: index + 1,
            name: dr.name,
            code: dr.code,
            state: false
        }));

        return data;
    } catch (error) {
        console.error("Error fetching locations:", error);
        return []; // Return empty array in case of error
    }
};



const getPriceModes = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    try {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}pricemode/select`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data }
        } else {
            return { success: false, data: [] }
        }

    } catch (error) {
        console.error('Error:', error);
    }
}


export {
    getCustomerBundles,
    getSupplierBundles,
    getCompany,
    SKU,
    SKUBundle,
    getTickets,
    getPaymentModes,
    getPromotionLocations,
    savePromotion,
    getPriceModes

}
